import { FileText } from 'lucide-react';
import type { ModuleSpec } from '../types';

export const templatesSpec: ModuleSpec = {
  id: 'templates',
  icon: FileText,
  i18n: {
    namespace: 'modules',
    titleKey: 'templates.title',
    descriptionKey: 'templates.description',
  },
  nav: {
    path: '/templates',
    group: 'build',
    order: 30,
  },
  meta: {
    status: 'active',
    description: 'Comprehensive template engine for multi-channel messaging',
  },
};
